import styled from 'astroturf/react';
import Footer from 'src/components/Footer';
import Header from 'src/components/Header';

const footer = styled(Footer)`
  padding: 30px 0 0;
  justify-content: space-between;
`;

const header = styled(Header)`
  margin-bottom: 3px;
`;

const layout = styled('div')`
  position: relative;
  min-height: 100%;
  height: 100%;
  @media screen and (max-width: 600px) {
    width: 100%;
    position: fixed;
  }
`;

export default {
  Footer: footer,
  Layout: layout,
  Header: header,
};
